import React, { SVGAttributes } from 'react';

// rationale: SVG paths are looooong
/* eslint-disable max-len */

export function Hyperlink(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none' {...props}>
      <path d='M4.2915 8.30436L8.30192 4.29395' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M4.66789 6.30752C4.42765 6.29367 4.1872 6.33075 3.96228 6.41632C3.73737 6.50189 3.53308 6.63402 3.36279 6.80404L2.50341 7.66342C2.18108 7.98575 2 8.42292 2 8.87877C2 9.33461 2.18108 9.77178 2.50341 10.0941C2.82574 10.4164 3.26292 10.5975 3.71876 10.5975C4.1746 10.5975 4.61178 10.4164 4.93411 10.0941L5.79348 9.23474C5.96351 9.06445 6.09564 8.86016 6.18121 8.63524C6.26677 8.41033 6.30385 8.16988 6.29001 7.92963'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.92585 6.29001C8.16609 6.30383 8.40654 6.26674 8.63145 6.18117C8.85635 6.0956 9.06065 5.96349 9.23095 5.79348L10.0903 4.93411C10.4127 4.61178 10.5937 4.1746 10.5937 3.71876C10.5937 3.26292 10.4127 2.82574 10.0903 2.50341C9.768 2.18108 9.33082 2 8.87498 2C8.41914 2 7.98196 2.18108 7.65963 2.50341L6.80026 3.36279C6.63063 3.53328 6.4989 3.73766 6.41367 3.96255C6.32843 4.18745 6.29162 4.4278 6.30564 4.66789'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
